import {
  FC,
  ReactElement,
  useState,
  useEffect,
  lazy,
  Suspense,
  useLayoutEffect,
} from 'react';
import { IRouteComponentProps, history } from 'umi';
import { useSelector, useDispatch } from 'dva';
import { Typography, LocaleProvider } from 'iglooform';
import { IntlProvider, FormattedMessage, defineMessages } from 'react-intl';
import './style/layout.less';
import PcContext from '@/utils/context';
import { Layout as AntLayout, Menu, Dropdown, Grid, Drawer } from 'antd';
// import CustomerFooter from '@/components/footer/footer';
import SwitchLang from '@/components/switch-lang/switch-lang';
import { updateRequest } from '@/service/request';
import {
  AccountOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  BurgerMenuOutlined,
  RefundOutlined,
  OverviewOutlined,
  ShopOutlined,
  CheckOutlined,
  InvoiceOutlined,
} from 'iglooicon';
import en from '@/locales/en-US';
import vn from '@/locales/vi-VN';
import Loading from '@/components/loading-spin/loading';
import { images } from '@/assets/images';

const { Header, Content } = AntLayout;
const { useBreakpoint } = Grid;

//
const locales: any = {
  'vi-VN': vn,
  'en-US': en,
};

type Menus = {
  key: string;
  title: string;
}[];

const Menus: Menus = [
  {
    key: 'home',
    title: 'Home',
  },
  {
    key: 'customers',
    title: 'Customers',
  },
  {
    key: 'earnings',
    title: 'Earnings',
  },
  {
    key: 'policies',
    title: 'Policies',
  },
];

const MePage = lazy(() => import('@/pages/me'));

const MenuIntl: { [key: string]: any } = defineMessages({
  home: { id: 'Home' },
  customers: { id: 'Customers' },
  earnings: { id: 'Earnings' },
  policies: { id: 'Policies' },
});

const Layout: FC<IRouteComponentProps> = ({
  children,
  location,
}: IRouteComponentProps): ReactElement => {
  const screens = useBreakpoint(); // get the screen size: lg, md, sm, xl, xs, xxl

  const isPc = !screens['xs'];
  const [meVisible, setMeVisible] = useState<boolean>(false);
  let { currentLang, menuKey } = useSelector<ReduxState, GlobalState>(
    (state) => state.global,
  );
  currentLang = localStorage.getItem('selected_lang') ?? 'vi-VN'; // 从storage获取选中的语言

  const dispatch = useDispatch();
  const token = localStorage.getItem(TOKEN_NAME);

  const [markPath, setMarkPath] = useState<string>('');

  const hideHeader = location.pathname.includes('/grow/insurance-basics');

  const getMenus = () => (
    <Menu
      theme="light"
      mode={'horizontal'}
      defaultSelectedKeys={['home']}
      selectedKeys={[menuKey ?? '']}
      onClick={handleSelect}
      className="menu"
    >
      {Menus.map(({ key }) => (
        <Menu.Item key={key}>
          <Typography
            level="body1"
            style={menuKey === key ? { fontWeight: 700 } : {}}
          >
            <FormattedMessage {...MenuIntl[key]} />
          </Typography>
        </Menu.Item>
      ))}
    </Menu>
  );

  const IconsWithH5 = (key: string) => {
    switch (key) {
      case 'home':
        return <ShopOutlined style={{ fontSize: '24px' }} />;
      case 'customers':
        return <OverviewOutlined style={{ fontSize: '24px' }} />;
      case 'earnings':
        return <RefundOutlined style={{ fontSize: '24px' }} />;
      case 'policies':
        return <InvoiceOutlined style={{ fontSize: '24px' }} />;
      default:
        break;
    }
  };

  const getH5Menus = () => (
    <Menu
      theme="light"
      defaultSelectedKeys={['home']}
      selectedKeys={[menuKey ?? '']}
      onClick={handleSelect}
      className="h5-menu"
      style={{ width: window.screen.width, padding: '0' }}
    >
      {Menus.map(({ key }) => (
        <Menu.Item key={key} className="h5-menu-item" icon={IconsWithH5(key)}>
          <Typography
            level="body1"
            style={menuKey === key ? { fontWeight: 700 } : {}}
          >
            <FormattedMessage {...MenuIntl[key]} />
          </Typography>
          {key === menuKey && (
            <CheckOutlined style={{ fontSize: '24px', float: 'right' }} />
          )}
        </Menu.Item>
      ))}
    </Menu>
  );

  useLayoutEffect(() => {
    if (!window.gtag) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      window.gtag = function () {};
    }
  }, []);

  useEffect(() => {
    return;
    const { pathname } = location;
    console.log(pathname, pathname.includes('/grow/insurance-basics'));
    let menuK = '';
    if (pathname.includes('/onboarding')) {
      localStorage.clear();
    }
    if (!token) {
      pathname.includes('/onboarding') ||
      pathname.includes('/login') ||
      pathname.includes('/grow/insurance-basics')
        ? ''
        : history.push('/login');
      return;
    } else if (pathname === '/login/set-payment-password') {
      history.push('/login/set-payment-password');
      return;
    }
    // 考虑一下 直接copy link进入的情况
    if (pathname.length && token) {
      if (pathname === '/') {
        menuK = 'home';
      } else if (pathname.includes('/me')) {
        menuK = '';
      } else if (
        pathname.includes('/login')
        // || pathname.includes('/onboarding') // 在token存在的情况下路由可以跳转到/onboarding/otp进行email验证
      ) {
        history.push('/home');
        menuK = 'home';
      } else {
        menuK = pathname.split('/')[1];
      }
    }

    if (
      localStorage.getItem('FORGOTPAYMENTPATHNAME') ===
      '/me/forget-payment-password'
    ) {
      setMarkPath(pathname);
    }

    updateRequest(localStorage.getItem(SELECTED_LANG) || 'vi-VN');

    dispatch({
      type: 'global/setData',
      payload: {
        menuKey: menuK,
      },
    });

    return localStorage.removeItem('FORGOTPAYMENTPATHNAME');
  }, [token, location.pathname]);

  useEffect(() => {
    if (Number(localStorage.getItem('EMAILCOUNTDOWN')) > 0) {
      const emailTimer = setInterval(() => {
        if (Number(localStorage.getItem('EMAILCOUNTDOWN')) - 1 <= 0) {
          localStorage.removeItem('EMAILCOUNTDOWN');
          window.clearInterval(emailTimer);
        }
        localStorage.setItem(
          'EMAILCOUNTDOWN',
          String(Number(localStorage.getItem('EMAILCOUNTDOWN')) - 1),
        );
      }, 1000);
    }

    if (Number(localStorage.getItem('COUNTDOWN')) > 0) {
      const emailTimer = setInterval(() => {
        if (Number(localStorage.getItem('COUNTDOWN')) - 1 <= 0) {
          localStorage.removeItem('COUNTDOWN');
          window.clearInterval(emailTimer);
        }
        localStorage.setItem(
          'COUNTDOWN',
          String(Number(localStorage.getItem('COUNTDOWN')) - 1),
        );
      }, 1000);
    }
  }, [markPath]);

  const handleSelect = ({ key }: any) => {
    history.push(`/${key}`);
    dispatch({
      type: 'global/setData',
      payload: {
        menuKey: key,
      },
    });
  };
  // 临时通过路由给背景设为浅灰色
  // const ifSetBgColor = location.pathname.includes('business-management');

  // onboarding/otp路由下不展示menu和me
  const isNotOtp = !location.pathname.includes('/onboarding/otp');

  return (
    <PcContext.Provider value={{ isPc: isPc }}>
      <IntlProvider
        locale={currentLang || 'vi-VN'}
        messages={locales[currentLang || 'vi-VN'] || vn}
      >
        <LocaleProvider currentLang={currentLang || 'vi-VN'}>
          <AntLayout
            className="layout"
            style={{
              minHeight: '100vh',
              overflowX: 'hidden',
              overflowY: 'hidden',
            }}
          >
            {!hideHeader && (
              <Header className={isPc ? 'layout-header' : 'layout-header-H5'}>
                <div style={{ width: '900px' }}>
                  <img src={images.ignite} alt="" className="logo" />
                  {token && isPc && isNotOtp && getMenus()}
                </div>

                <div className="right-box">
                  {isPc ? (
                    <SwitchLang className="switch-lang" />
                  ) : (
                    !isNotOtp && <SwitchLang className="switch-lang" />
                  )}
                  {token && !isPc && isNotOtp && (
                    //
                    <Dropdown
                      placement="bottom"
                      overlay={
                        <Suspense fallback={<Loading />}>
                          {getH5Menus()}
                        </Suspense>
                      }
                      trigger={isPc ? ['hover'] : ['click']}
                      getPopupContainer={(trigger) =>
                        trigger.parentElement || document.body
                      }
                      // onVisibleChange={(visible) => setMeVisible(visible)}
                      // visible={meVisible}
                    >
                      <div className="dropdown">
                        <BurgerMenuOutlined className="account-icon" />
                      </div>
                    </Dropdown>
                  )}
                  {token && isPc && isNotOtp && (
                    <Dropdown
                      placement="bottomLeft"
                      overlay={
                        <Suspense fallback={<Loading />}>
                          <MePage
                            menuClickCallback={() => setMeVisible(false)}
                          />
                        </Suspense>
                      }
                      trigger={isPc ? ['hover'] : ['click']}
                      getPopupContainer={(trigger) =>
                        trigger.parentElement || document.body
                      }
                      onVisibleChange={(visible) => setMeVisible(visible)}
                      visible={meVisible}
                    >
                      <div className="dropdown">
                        <AccountOutlined className="account-icon" />
                        {meVisible ? (
                          <ArrowUpOutlined className="down-icon" />
                        ) : (
                          <ArrowDownOutlined className="down-icon" />
                        )}
                      </div>
                    </Dropdown>
                  )}
                  {token && !isPc && isNotOtp && (
                    <div className="dropdown" style={{ marginLeft: '8px' }}>
                      <AccountOutlined
                        className="account-icon"
                        onClick={() => setMeVisible(true)}
                      />
                      <Drawer
                        visible={meVisible}
                        onClose={() => setMeVisible(false)}
                        placement="bottom"
                        height={'100vh'}
                      >
                        <Suspense fallback={<Loading />}>
                          <MePage
                            menuClickCallback={() => setMeVisible(false)}
                          />
                        </Suspense>
                      </Drawer>
                    </div>
                  )}
                </div>
              </Header>
            )}

            <Content
              className={
                isPc ? 'site-layout-content' : 'site-layout-content-H5'
              }
              style={
                location.pathname === '/onboarding' ||
                (location.pathname.includes('/policies/detail') && !isPc) ||
                location.pathname.includes('/me/edit-profile') ||
                location.pathname.includes('/grow/insurance-basics') ||
                location.pathname.includes('/me/forget-payment-password')
                  ? location.pathname === '/onboarding' ||
                    location.pathname.includes('/grow/insurance-basics')
                    ? { padding: '0', background: '#fff' }
                    : { background: '#fff' }
                  : {}
              }
            >
              {children}
            </Content>
            {/* <CustomerFooter
              email="cs.vn@iglooinsure.com"
              address={`Floor 7, VPBank Building, 5 Dien Bien Phu, Cua Nam Ward, Ba Dinh District, Hanoi, Vietnam`}
              tel="+84 888994664"
              workTime={'09:00 AM - 06:00 PM'}
            /> */}
          </AntLayout>
        </LocaleProvider>
      </IntlProvider>
    </PcContext.Provider>
  );
};

export default Layout;
